import { createAsyncThunk } from '@reduxjs/toolkit';
import { dataSourceFiltersActionName } from './actionTypes';
import { DataSourceFiltersService } from '../../services/DataSourceFiltersService';

const service = DataSourceFiltersService;

export const fetchDataSourceFiltersAction = createAsyncThunk(dataSourceFiltersActionName, async () => {
  return await service.getDataSourceFilters();
});
